// extracted by mini-css-extract-plugin
export default {"root":"FieldLoading_root__AE-zj","box":"FieldLoading_box__IYeP1","placeholder":"FieldLoading_placeholder__OvJox","spinner":"FieldLoading_spinner__oG6+L"};